import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.funcion.fields.id'),
  },
  {
    name: 'nombre',
    label: i18n('entities.funcion.fields.nombre'),
  },
  {
    name: 'createdAt',
    label: i18n('entities.funcion.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.funcion.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
